import { request, buildQuery } from '../../lib/apiClient';
export function listSuppliers(params) {
    const query = buildQuery({
        status: params?.status,
        category: params?.category,
        name: params?.name,
        limit: params?.limit,
        nextToken: params?.nextToken,
    });
    return request(`/suppliers${query}`);
}
export function getSupplier(id) {
    return request(`/suppliers/${id}`);
}
export function createSupplier(input) {
    return request('/suppliers', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function updateSupplier(id, input) {
    return request(`/suppliers/${id}`, {
        method: 'PUT',
        body: JSON.stringify(input),
    });
}
export function deleteSupplier(id) {
    return request(`/suppliers/${id}`, {
        method: 'DELETE',
    });
}
//# sourceMappingURL=api.js.map